import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  () => ({
    desktopModalPaper: {
      width: "100%",
      padding: ({ isDesktop }) =>
        isDesktop ? "20px !important" : "20px 18px !important",
      fontWeight: "400",
    },

    mobile_modal_paper: {
      fontWeight: "400",
      modalBody: ({ isDesktop }) => (isDesktop ? "20px" : "0px"),
    },
  }),
  { name: "CreatorTool" }
);

export default useStyles;
